/* TU compare tray: cross-range comparison.
   Selection lives in localStorage (max 4 handles). Product data comes from the
   alternate template /products/<handle>?view=compare-json and is cached in
   sessionStorage so reopening the table costs nothing. */
(function () {
  'use strict';
  var KEY = 'tu_compare';
  var MAX = 4;

  function read() {
    try { return (JSON.parse(localStorage.getItem(KEY)) || []).slice(0, MAX); }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    render();
  }
  function money(cents) {
    if (cents === null || cents === undefined) return '';
    return '$' + (cents / 100).toFixed(2);
  }

  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem('tu_cmp_' + handle)); } catch (e) {}
    if (stored) { cache[handle] = stored; return Promise.resolve(stored); }
    return fetch('/products/' + handle + '?view=compare-json')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var data = JSON.parse(t.trim());
        cache[handle] = data;
        try { sessionStorage.setItem('tu_cmp_' + handle, JSON.stringify(data)); } catch (e) {}
        return data;
      });
  }

  /* ---------- tray ---------- */
  function render() {
    var tray = document.getElementById('tu-compare-tray');
    if (!tray) return;
    var list = read();
    tray.hidden = list.length === 0;
    var items = tray.querySelector('[data-tu-ct-items]');
    var count = tray.querySelector('[data-tu-ct-count]');
    var go = tray.querySelector('[data-tu-ct-open]');
    count.textContent = list.length;
    go.disabled = list.length < 2;
    items.innerHTML = '';
    list.forEach(function (h) {
      var chip = document.createElement('div');
      chip.className = 'tu-ct__chip';
      chip.innerHTML = '<img alt="" loading="lazy"><button type="button" aria-label="Remove">&times;</button>';
      chip.querySelector('button').addEventListener('click', function () { remove(h); });
      items.appendChild(chip);
      fetchProduct(h).then(function (d) {
        var img = chip.querySelector('img');
        if (d.image) { img.src = d.image; img.alt = d.title; }
        chip.title = d.title;
      }).catch(function () {});
    });
    syncButtons();
  }

  function add(handle) {
    var list = read();
    if (list.indexOf(handle) !== -1) return;
    if (list.length >= MAX) list = list.slice(1);
    list.push(handle);
    write(list);
  }
  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-tu-compare-add]').forEach(function (btn) {
      var h = btn.getAttribute('data-tu-compare-add');
      var on = list.indexOf(h) !== -1;
      btn.classList.toggle('is-added', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-tu-compare-label]');
      if (label) label.textContent = on ? 'Added to compare' : 'Add to compare';
    });
  }

  /* ---------- comparison table ---------- */
  function openModal() {
    var list = read();
    if (list.length < 2) return;
    var modal = document.getElementById('tu-compare-modal');
    var body = modal.querySelector('[data-tu-ct-body]');
    body.innerHTML = '<p>Loading…</p>';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    Promise.all(list.map(fetchProduct)).then(function (items) {
      body.innerHTML = '';
      body.appendChild(buildTable(items));
    }).catch(function () {
      body.innerHTML = '<p>Sorry, the comparison could not be loaded. Please try again.</p>';
    });
  }
  function closeModal() {
    var modal = document.getElementById('tu-compare-modal');
    if (modal) modal.hidden = true;
    document.body.style.overflow = '';
  }

  function parseSpecs(str) {
    var out = {};
    (str || '').split('\n').forEach(function (line) {
      var i = line.indexOf(':');
      if (i > 0) out[line.slice(0, i).trim()] = line.slice(i + 1).trim();
    });
    return out;
  }

  function cellFor(value) {
    var td = document.createElement('td');
    var v = (value || '').toLowerCase();
    if (v === 'yes') { td.innerHTML = '<span class="tu-ct__yes">&#10003;</span>'; }
    else if (v === 'no') { td.innerHTML = '<span class="tu-ct__no">&#10005;</span>'; }
    else { td.textContent = value || '—'; }
    return td;
  }

  function buildTable(items) {
    var specs = items.map(function (d) { return parseSpecs(d.specs); });
    var labels = [];
    specs.forEach(function (s) {
      Object.keys(s).forEach(function (k) { if (labels.indexOf(k) === -1) labels.push(k); });
    });

    var table = document.createElement('table');
    table.className = 'tu-ct__table';

    var thead = document.createElement('thead');
    var hr = document.createElement('tr');
    hr.appendChild(document.createElement('th'));
    items.forEach(function (d) {
      var th = document.createElement('th');
      var img = d.image ? '<img src="' + d.image + '" alt="' + d.title.replace(/"/g, '&quot;') + '">' : '';
      th.innerHTML = img +
        '<a class="tu-ct__name" href="' + d.url + '">' + d.title + '</a>' +
        '<span class="tu-ct__price">' + money(d.price) +
        (d.compare_at_price && d.compare_at_price > d.price ? ' <s>' + money(d.compare_at_price) + '</s>' : '') +
        '</span>' +
        '<a class="tu-ct__view" href="' + d.url + '">View</a>';
      hr.appendChild(th);
    });
    thead.appendChild(hr);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');

    function row(label, values, isHtml) {
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      th.scope = 'row';
      th.textContent = label;
      tr.appendChild(th);
      values.forEach(function (v) {
        if (isHtml) { var td = document.createElement('td'); td.innerHTML = v; tr.appendChild(td); }
        else tr.appendChild(cellFor(v));
      });
      tbody.appendChild(tr);
    }

    row('Availability', items.map(function (d) { return d.available ? 'In stock' : 'Sold out'; }));
    row('Warranty', items.map(function (d) { return d.warranty || '—'; }));
    labels.forEach(function (label, i) {
      row(label, specs.map(function (s) { return s[label] || ''; }));
    });
    var anyBenefits = items.some(function (d) { return d.benefits && d.benefits.length; });
    if (anyBenefits) {
      row('Highlights', items.map(function (d) {
        return (d.benefits || []).map(function (b) { return '<div>' + b + '</div>'; }).join('') || '—';
      }), true);
    }

    table.appendChild(tbody);
    var wrap = document.createElement('div');
    wrap.style.overflowX = 'auto';
    wrap.appendChild(table);
    return wrap;
  }

  /* ---------- wiring ---------- */
  function init() {
    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest && e.target.closest('[data-tu-compare-add]');
      if (addBtn) {
        e.preventDefault();
        var h = addBtn.getAttribute('data-tu-compare-add');
        if (read().indexOf(h) !== -1) remove(h); else add(h);
        return;
      }
      if (e.target.closest && e.target.closest('[data-tu-ct-open]')) { openModal(); return; }
      if (e.target.closest && e.target.closest('[data-tu-ct-close]')) { closeModal(); return; }
      if (e.target.closest && e.target.closest('[data-tu-ct-clear]')) { write([]); return; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    render();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
